import styles from './Textarea.module.scss'
import React from 'react'
import { Roboto } from "next/font/google"
import classNames from 'classnames'

const roboto = Roboto({
  subsets: ['latin'],
  weight: ['400'],
})


type Props = {
  name: string,
  value?: string,
  onChange?: (value: string, name: string) => void,
  placeholder?: string,
  error?: string,
}

const Textarea = (props: Props) => {
  const onChangeHandler = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const { name, value } = event.target

    if (props.onChange === undefined)
      return

    props.onChange(value, name)
  }

  const classes = classNames(
    styles.textarea,
    roboto.className,
    {
      [styles.error]: props.error,
    }
  )

  return (
    <div>
      <textarea
        className={classes}
        name={props.name}
        onChange={onChangeHandler}
        placeholder={props.placeholder}
        value={props.value}
      />
      {props.error && (
        <div className={styles.errorText}>
          {props.error}
        </div>
      )}
    </div>
  )
}

export default Textarea